import React, { useEffect, useState } from 'react'
import { useGetContractPeriodQuery } from '../../../store/auth/authService'
import moment from 'moment'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import FilterDatePeriodYear from '../../tableHelpers/filters/FilterDatePeriodYear'
import FilterDatePeriodYearDrawer from '../../tableHelpers/filters/FilterDatePeriodYearDrawer'
import { ImageDownloadButton } from '../ImageDownloadButton' 
import { ConsFormType } from '../common.types'

const FiltersViewComparison = (props: {
    value: ConsFormType,
    isLoadingFetch: boolean,
    isForSave: boolean,
    fetchPage: any,
    savePicture: any,
    saveExcel?: any,
}) => {
    const {
        value,
        isLoadingFetch,
        isForSave,
        fetchPage,
        savePicture,
        saveExcel,
    } = props

    const { t } = useTranslation()
    const { param_contract_id } = useParams()
    const { data } = useGetContractPeriodQuery({
        contract_id: param_contract_id,
        endOffset: 3
    })
    const {
        control,
        getValues,
        setValue,
    } = useForm<ConsFormType>({
        defaultValues: {},
    })

    useEffect(() => {
        setValue('periodFrom', value.periodFrom)
        setValue('periodTo', value.periodTo)

    }, [value]);


    const [filtersState, setFiltersState] = useState<ConsFormType>(value);

    const handleCloseFilter = () => {
        const values = getValues()
        setFiltersState(values)
        if (JSON.stringify(values) !== JSON.stringify(filtersState)) {
            // fetch page with new filters 
            fetchPage(values)
        }
    }

    return (

        <div className='grid grid-cols-2 tab:flex justify-between items-center mb-[24px] lap:mb-[32px] mt-[12px] gap-[8px]'>
            <FilterDatePeriodYearDrawer
                isLoadingFetch={isLoadingFetch || !value.periodFrom}
                placement={'bottom-start'}
                control={control}
                fieldName1={'periodFrom'}
                fieldName2={'periodTo'}
                label1={t("filters.period_from")}
                label2={t("filters.period_to")}
                datesData={data}
                handleCloseFilter={handleCloseFilter}
            />
            <div className='hidden tab:flex flex-wrap justify-between grow items-center gap-[8px]'>
                <FilterDatePeriodYear
                    isLoadingFetch={isLoadingFetch || !value.periodFrom}
                    placement={'bottom-start'}
                    control={control}
                    fieldName1={'periodFrom'}
                    fieldName2={'periodTo'}
                    label1={t("filters.period_from")}
                    label2={t("filters.period_to")}
                    datesData={data}
                    handleCloseFilter={handleCloseFilter}
                    isDisabled1={(date: string) => {
                        return false
                    }}
                    isDisabled2={(date: string) => {
                        return moment(filtersState.periodFrom, 'MM-YYYY').add(1, 'month').isAfter(moment(date, 'MM-YYYY'))
                    }}
                    dateFormatter1={(date: string, dateTo: string) => {
                        if (moment(date, 'MM-YYYY').isAfter(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(11, 'month').isBefore(moment(dateTo, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(1, 'month').isAfter(moment(dateTo, 'MM-YYYY'))) {
                            return moment(date, 'MM-YYYY').add(11, 'month').format('MM-YYYY')
                        }
                        else {
                            return dateTo
                        }
                    }}
                    dateFormatter2={(date: string, dateFrom: string) => {
                        if (moment(date, 'MM-YYYY').isBefore(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(-11, 'month').isAfter(moment(dateFrom, 'MM-YYYY')) || moment(date, 'MM-YYYY').add(-1, 'month').isBefore(moment(dateFrom, 'MM-YYYY'))) {
                            return moment(date, 'MM-YYYY').add(-11, 'month').format('MM-YYYY')
                        }
                        else {
                            return dateFrom
                        }
                    }}
                />
            </div>

            <ImageDownloadButton
                text={t('download')}
                handleDownloadPng={savePicture}
                handleDownloadExcel={saveExcel}
                disabled={isLoadingFetch || !isForSave}
            />
        </div>
    )
}

export default FiltersViewComparison